<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div :class="`${contentDisplayInfo.popupContentAreaSmallClass} ${contentDisplayInfo.popupContentBackgroundClass}`">
      <el-form
        :model="validatorForm"
        :rules="rules"
        label-width="100px"
        ref="validatorForm"
      >
        <div>
          <el-row class="cs-validator-main">
            <el-col :span="contentDisplayInfo.csValidatorMainLeftSpan">
              &nbsp;
            </el-col>
            <el-col :span="contentDisplayInfo.csValidatorMainCenterSpan">
              <div class="grid-content">
                <div v-if="showPhone">
                  <el-form-item
                    prop="phoneType"
                    label="手机号码"
                  >
                    <el-select
                      v-model="validatorForm.phoneType"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in phoneTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    prop="phone"
                    label=""
                    class="su-phone"
                  >
                    <el-input
                      placeholder="请输入手机号码"
                      v-model="validatorForm.phone"
                      maxlength="11"
                    ></el-input>
                  </el-form-item>
                </div>
                <el-form-item class="su-left-align cs-validator-code">
                  <el-button
                    :disabled="smsBtnDisable"
                    :type="smsBtnClass"
                    @click="smsBtnClick"
                    class="smsBtn"
                    size="small"
                  >{{smsBtnText}}</el-button>
                 
                </el-form-item>
                <el-form-item
                  prop="code"
                  label="验证码"
                >
                  <el-row>
                    <el-col :span="contentDisplayInfo.isDialog ? 24 : 20">
                      <el-input
                        placeholder="请输入收到的验证码"
                        v-model="validatorForm.code"
                      ></el-input>
                    </el-col>
                    <el-col
                      :span="4"
                      v-if="!contentDisplayInfo.isDialog"
                    >
                      <el-button
                        type="primary"
                        @click="validateCode"
                        size="small"
                        class="cs-validator-btn"
                      >验证</el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item
                  v-if="!contentDisplayInfo.isDialog && showError"
                  class="su-left-align cs-validator-btn-container"
                >
                  <div class="errorMessageContainer">
                    <el-alert
                      class="cs-validator-alert"
                      :closable="false"
                      v-if="showError"
                      v-bind:title="errorMessage"
                      type="error"
                      show-icon
                    ></el-alert>
                  </div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="contentDisplayInfo.csValidatorMainRightSpan">
              &nbsp;
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer popup-footer"
      v-if="contentDisplayInfo.isDialog"
    >
      <el-row>
        <el-col
          :span="20"
          :xs="16"
          class="footer-left"
        >
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            :title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col
          class="footer-right"
          :span="4"
          :xs="8"
        >
          <el-button
            type="primary"
            @click="validateCode"
          >验证</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.popup-content-area-small {
  min-height: auto;
  padding: 0px;
}

.popup-content-area-small-dialog {
  min-height: 350px;
  padding: 50px;
}

.validatorForm {
  text-align: left;
}

.su-title {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

.grid-content {
  .su-phone {
    margin-bottom: 15px;
  }
}

.el-form-item {
  margin-bottom: 10px;

  &.is-required {
    label {
      &:before {
        content: "";
      }
    }
  }
}

.smsBtn {
  width: 150px;
}

.cs-validator-btn {
  margin-left: 5px;
}

.cs-validator-btn-container {
  // margin-top: 10px;
  // margin-bottom: 10px;
  text-align: left;
}

.errorMessageContainer {
  display: inline-block;
  vertical-align: middle;
  // min-height: 56px;

  .cs-validator-alert {
    padding: 0 10px;
  }
}
</style>

<script>
import { getPhoneTypeList } from "@/service/api-base.service";
import { sendSMS, validateSMSCode } from "@/service/common.service";

export default {
  props: {
    isDialog: Boolean,
    align: String,
    showPhone: Boolean,
    dataIn: {
      salesQueryRow: Object,
      phone: String
    }
  },
  data() {
    var validatePhone = (rule, value, callback) => {
      let message = "";

      if (!value) {
        message = "请输入手机号码";
      } else {
        if (this.validatorForm.phoneType == 1) {
          if (value.length != 10) {
            message = "请输入10位数北美手机号";
          }
        } else {
          if (value.length != 11) {
            message = "请输入11位数中国手机号";
          }
        }
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      showError: false,
      errorMessage: "",
      smsBtnText: "发送验证码",
      smsBtnDisable : false,
      smsBtnClass : "primary",
      isSendSMS: false,
      timer: null,
      contentDisplayInfo: {
        isDialog: false,
        contentAlign: "center",
        csValidatorMainLeftSpan: 5,
        csValidatorMainCenterSpan: 14,
        csValidatorMainRightSpan: 5,
        popupContentAreaSmallClass: "popup-content-area-small-dialog",
        popupContentBackgroundClass: "backgroud-gray-popup"
      },
      phoneTypeList: [],
      validatorForm: {
        phoneType: 1,
        phone: "",
        code: ""
      },
      rules: {
        phoneType: [
          {
            required: true,
            message: "请选择号码归属地",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    ContentAlign: {
      get: function() {
        return this.contentDisplayInfo.contentAlign;
      },
      set: function(value) {
        this.contentDisplayInfo.contentAlign = value;
        this.resetContentDisplayStyle();
      }
    }
  },
  created() {
    this.phoneTypeList = getPhoneTypeList();
    this.init();
  },
  methods: {
    init() {
      this.contentDisplayInfo.isDialog = this.isDialog;
      this.ContentAlign = this.align;
      this.loadDataInFromProps();
    },
    clear() {
      this.showError = false;
      this.errorMessage = "";

      this.validatorForm = {
        phoneType: 1,
        phone: "",
        code: ""
      };
    },
    resetContentDisplayStyle() {
      if (this.contentDisplayInfo.isDialog) {
        this.contentDisplayInfo.csValidatorMainCenterSpan = 14;
        this.contentDisplayInfo.popupContentAreaSmallClass =
          "popup-content-area-small-dialog";
        this.contentDisplayInfo.popupContentBackgroundClass =
          "backgroud-gray-popup";
      } else {
        this.contentDisplayInfo.csValidatorMainCenterSpan = 14;
        this.contentDisplayInfo.popupContentAreaSmallClass =
          "popup-content-area-small";
        this.contentDisplayInfo.popupContentBackgroundClass = "backgroud-white";
      }

      let totalSpanLeftAndRight =
        24 - this.contentDisplayInfo.csValidatorMainCenterSpan;
      switch (this.contentDisplayInfo.contentAlign) {
        case "left":
          this.contentDisplayInfo.csValidatorMainLeftSpan = 0;
          this.contentDisplayInfo.csValidatorMainRightSpan = totalSpanLeftAndRight;
          break;
        case "center":
          this.contentDisplayInfo.csValidatorMainLeftSpan = Math.floor(
            totalSpanLeftAndRight / 2
          );
          this.contentDisplayInfo.csValidatorMainRightSpan = Math.floor(
            totalSpanLeftAndRight / 2
          );
          break;
        case "right":
          this.contentDisplayInfo.csValidatorMainLeftSpan = totalSpanLeftAndRight;
          this.contentDisplayInfo.csValidatorMainRightSpan = 0;
          break;
      }
    },
    checkFieldValidate(fieldName) {
      let fieldValid = true;
      if (!!this.$refs["validatorForm"]) {
        this.$refs["validatorForm"].validate((valid, elements) => {
          if (fieldName in elements) {
            fieldValid = false;
          }
        });
      }
      return fieldValid;
    },
    loadDataInFromProps(dataIn = this.dataIn) {
      if (!dataIn) return;
      this.smsBtnDisable = false;
      this.clear();

      this.validatorForm.phone = dataIn.phone;
      this.__changePhoneTypeByPhone(this.validatorForm.phone);
    },
    async smsBtnClick() {
      if (this.isSendSMS) return;

      if (!this.checkFieldValidate("phone")) {
        this.$message({
          message: "请先输入有效的电话号码！",
          type: "warning"
        });
        return false;
      }
      this.smsBtnDisable = true;
      await sendSMS(this.validatorForm.phone, 10).then(result => {
        if (!!result) {
          if (result.success) {
            this.$message("验证码发送成功，请注意查收！");
            this.afterSMSSend();
          } else {
            if (result.message) {
              this.$message({
                message: result.message,
                type: "error"
              });
              this.smsBtnDisable = false;
            }
          }
        }
      });
    },
    afterSMSSend() {
      this.isSendSMS = true;
      this.setSMSBtnState(true);
      let count = 60;
      this.smsBtnText = count.toString() + "秒后重新发送";

      let self = this;
      if (self && !self._isDestroyed) {
        self.timer = setInterval(() => {
          if (self && !self._isDestroyed) {
            count--;
            if (count == 0) {
              this.isSendSMS = false;
              this.setSMSBtnState(false);
              this.smsBtnText = " 发送验证码 ";
              clearInterval(self.timer);
            } else {
              this.smsBtnText = count.toString() + "秒后重新发送";
            }
          }
        }, 1000);
      }
    },
    setSMSBtnState(isDisable) {
      if (isDisable) {
        this.smsBtnDisable = true;
        this.smsBtnClass = "info";
      } else {
        this.smsBtnDisable = false;
        this.smsBtnClass = "primary";
      }
    },
    async validateCode() {
   
      this.showError = false;
      this.errorMessage = "";
      if (!!this.$refs["validatorForm"]) {
        let isValid = true;
        this.$refs["validatorForm"].validate(valid => {
          if (valid) {
          } else {
            isValid = false;
          }
        });
        if (!isValid) {
          return false;
        }

      
        let result = await validateSMSCode(
          this.validatorForm.phone,
          this.validatorForm.code,
          10
        );
       
        if (!result) return false;

        if (!result.success) {
          this.errorMessage = result.message;
          this.showError = true;
          return false;
        }

        this.triggerValidateSuccess();
      }
    },
    triggerValidateSuccess() {
      let dataOut = {
        row: this.dataIn.salesQueryRow
      };
      this.$emit("validateSuccess", dataOut);
    },
    __changePhoneTypeByPhone(phone) {
      this.validatorForm.phoneType = !!phone && phone.length == 11 ? 2 : 1;
    }
  },
  watch: {
    dataIn: function(newVal) {
      this.loadDataInFromProps(newVal);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/JoinWeChatGroupValidator.vue